import React, { Fragment, useEffect, useState, useCallback, useMemo } from 'react';
import PropTypes from 'prop-types'
import { Button, Card, CardContent, Divider, Grid, Typography } from '@mui/material';
import { useStyles } from './estilosHeader';

const ElementoCardHeader = ({tipoCargo, monto}) => {
  const classes = useStyles();
  return (
    <Grid item xs={12} md={4}>
      <Card style={{ minWidth: '100%', width: '100%' }}>
        <CardContent>
          <div className={classes.contenedorHeader}>
            <Typography className={classes.contenedorHeader_tipo}>{tipoCargo}</Typography>
            <Typography className={classes.contenedorHeader_monto}>{monto}</Typography>
          </div>
        </CardContent>
      </Card>
    </Grid>
  );
}

ElementoCardHeader.propTypes = {
  // localizer: PropTypes.instanceOf(DateLocalizer),
  dayLayoutAlgorithm: PropTypes.string,
}

export default ElementoCardHeader;